import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Camera } from '@ionic-native/camera/ngx';
import { IonicStorageModule } from '@ionic/storage';
import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from './components/components.module';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { AngularFireStorage, AngularFireStorageModule } from '@angular/fire/storage';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { OneSignal} from '@ionic-native/onesignal/ngx';
import { NativeAudio } from '@ionic-native/native-audio/ngx';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { Network } from '@ionic-native/network/ngx';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { Platform} from '@ionic/angular';
import PouchDB from 'pouchdb';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';

export const  firebase = {
	apiKey: "AIzaSyDEzpSQgzpXjB2m2eciT83vPoNMFWZxL8g",
    authDomain: "maxsellglobal-technology-937f6.firebaseapp.com",
    projectId: "maxsellglobal-technology-937f6",
    storageBucket: "maxsellglobal-technology-937f6.appspot.com",
    messagingSenderId:"995406275939",
    appId: "1:995406275939:web:c8c1fce083606794779f56",
    measurementId: "G-Q3N96NNQMC"
  };

 
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,
    IonicStorageModule.forRoot(), 
    AngularFireModule.initializeApp(firebase),
		AngularFireAuthModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
		AngularFirestoreModule,
		AngularFirestoreModule.enablePersistence(),
    ComponentsModule,
    Ng2SearchPipeModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    StatusBar,
    Storage,
    Camera,
    Platform,
    BarcodeScanner,
    Geolocation,
    NativeAudio,
    Network,
    SplashScreen,
    BackgroundMode,
    OneSignal,
    PouchDB,
    AngularFireStorage,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
